import store from "./store/store";
import BootstrapVue from "bootstrap-vue";
import IdleVue from "idle-vue";
import moment from "moment";
import VeeValidate from "vee-validate";
import Vue from "vue";
import VueMoment from "vue-moment";
import Toasted from "vue-toasted";
import VueNativeSock from 'vue-native-websocket';
import { EventBus } from "@/eventBus";

Vue.use(BootstrapVue);

Vue.use(IdleVue, {
  idleTime: 10000,
  eventEmitter: EventBus
});

Vue.use(Toasted, {
  duration: 4000,
  position: "top-right"
});

Vue.use(VueMoment, {
  moment
});

Vue.use(VeeValidate, {
  fieldsBagName: "veeFields",
  errorBagName: "veeErrors"
});

Vue.use(VueNativeSock, 'ws://mynd.lvh.me', { 
  store: store, 
  format: 'json',
  reconnection: true, // (Boolean) whether to reconnect automatically (false)
  reconnectionAttempts: 5, // (Number) number of reconnection attempts before giving up (Infinity),
  reconnectionDelay: 3000, // (Number) how long to initially wait before attempting a new (1000)
  connectManually: true
});

Vue.prototype.$confirmOptions = {
  title: "Confirmation",
  size: "md",
  okVariant: "primary",
  okTitle: "Yes",
  cancelVariant: "outline-secondary",
  cancelTitle: "Cancel",
  hideHeaderClose: false,
  centered: true
};
